import log from 'sentry/log'
import camelCaseKeys from 'utils/camelCase'

export const validateChannel = (channel) => {
  const initialData = {
    get ad() {
      let ad = null
      try {
        ad = JSON.parse(channel.data).ad
      } catch (error) {
        log.message("Chat: Couldn't parse JSON from channel.data")
      }
      return camelCaseKeys(ad) // we want the object keys to be in camelCase, not snake_case
    },
    adHasOverlay: false, // true will put overlays on default images
    adIsActive: true,
    adHasError: false,
    adIssueText: '',
  }

  try {
    const { ad } = initialData
    return {
      ad: initialData.ad,
      adHasError: ad === undefined || !ad,
      adIsActive: ad?.status.toLowerCase() === 'active',
      get adIssueText() {
        if (this.adHasError) {
          return 'Något är fel med annonsen'
        }

        if (!this.adIsActive) {
          return 'Borttagen'
        }

        return null
      },
      get adHasOverlay() {
        return !this.adIsActive && !ad?.image
      },
    }
  } catch (error) {
    log.message(`Chat: Could not find ad data: ', ${error}`)
  }

  return initialData
}
